<template>
    <div class="fixed inset-0 z-50 overflow-y-auto w-full bg-black bg-opacity-60">
      <div class="flex items-center justify-center min-h-screen">
        <div class="relative bg-white rounded-lg h-[300px] w-[450px] z-60 p-4">
          <button
            @click="$emit('closeModel')"
            class="absolute top-0 right-1 bg-white rounded-full p-1 z-50"
          >
            <svg
              class="h-6 w-6 fill-current text-gray-700 hover:text-gray-600 transition duration-150 ease-in-out"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            >
              <path
                fill-rule="evenodd"
                d="M10 8.586l4.95-4.95 1.414 1.414L11.414 10l4.95 4.95-1.414 1.414L10 11.414l-4.95 4.95-1.414-1.414L8.586 10 3.636 5.05l1.414-1.414L10 8.586z"
                clip-rule="evenodd"
              />
            </svg>
          </button>
  
          <!-- Thank You Message -->
          <div v-if="formSubmitted" class="p-6 text-center space-y-4">
            <h4 class="text-xl font-bold text-green-600">Thank you!</h4>
            <p>Your enquiry has been submitted successfully.</p>
            <button
              @click="$emit('closeModel')"
              class="mt-4 px-4 py-2 bg-[#94C34D] text-white rounded-lg hover:bg-[#7bb32c]"
            >
              Close
            </button>
          </div>
  
          <div v-else class="flex items-center justify-center">
            <div class="relative bg-white rounded-lg shadow-sm">
              <h4 class="font-bold text-lg px-2 py-2">
                Download Brochure
                <br />
              </h4>
              <div>
                <form
                  class="space-y-3 p-4 font-normal"
                  @submit.prevent="brochureSubmit"
                >
                  <input
                    type="text"
                    placeholder="Enter Name *"
                    id="FirstName"
                    class="p-1 rounded-md w-full border-gray-300"
                    v-model="formInfo.firstName"
                  />
                  <input
                    type="email"
                    placeholder="Enter Email Address *"
                    id="EmailAddress"
                    class="p-1 rounded-md w-full border-gray-300"
                    v-model="formInfo.email"
                  />
  
                  <input
                    type="tel"
                    placeholder="Enter Mobile Number *"
                    id="phone"
                    maxlength="10"
                    onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
                    class="p-1 rounded-md w-full border-gray-300"
                    v-model="formInfo.phone"
                    required
                  />
  
                  <button
                    type="submit"
                    class="w-full text-white bg-[#9C9B9D] hover:bg-[#94C34D] rounded-md px-4 py-2 text-center"
                  >
                    Download Brochure &#10148;
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import axios from "axios";
  export default {
    props: ["closeModel"],
    created() {
      this.widget_id = this.widget_prop_id;
    },
    data() {
      return {
        is_widget: false,
        showMenu: false,
        formSubmitted: false,
        formInfo: {
          firstName: "",
          email: "",
          phone: "",
        },
      };
    },
  
    methods: {
      async brochureSubmit(el) {
        console.log("formInput:::", el);
        const params = new URLSearchParams(window.location.search);
        const dataJson = {
          phone: this.formInfo.phone,
          name: this.formInfo.firstName,
          email: this.formInfo.email,
          university: "Yenepoya",
          programName: "",
          programElective: "",
          utmData: {
            utmSource: params.get("utm_source") || "",
            utmMedium: params.get("utm_medium") || "",
            utmCampaign: params.get("utm_campaign") || "",
            utmAdgroupId: params.get("utm_adgroup_id") || "",
            utmCreativeId: params.get("utm_creative_id") || "",
            utmDevice: params.get("utm_device") || "",
            utmNetwork: params.get("utm_network") || "",
            utmCampaignId: params.get("utm_campaign_id") || "",
            utmMatchType: params.get("utm_matchtype") || "",
            utmKeyword: params.get("utm_keyword") || "",
            utmPlacement: params.get("utm_placement") || "",
            utmURL: window.location.href,
          },
        };
  
        try {
          const resp = await axios.post(
            "https://authradar.onlinejain.com/user-management/api/v1/lead/register/",
            dataJson
          );
          if (resp.data.statusCode === 200) {
            await fetch(
              `https://api.onlineyenepoya.com/media/2026/overall-brochure.pdf`
            )
              .then((response) => response.blob())
              .then((blob) => {
                this.formSubmitted = true;
                const url = window.URL.createObjectURL(new Blob([blob]));
                const a = document.createElement("a");
                a.href = url;
                a.download = `Yenapoya-overall-brochure.pdf`;
                a.click();
              });
          }
        } catch (error) {
          console.log(error);
  
          this.errorMessage =
            error.response?.data?.ExceptionMessage || "Submission failed";
          setTimeout(() => (this.errorMessage = ""), 3000);
        }
      },
    },
  };
  </script>
  
  <style></style>